import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { TrendingUp, TrendingDown, AccountBalance, Assessment } from '@mui/icons-material';

interface FinancialOverviewRow1Props {
  totalIncome: number;
  totalExpense: number;
  fundBalance: number;
  supplierDebt: number;
  netFundAfterDebt: number;
  periodLabel: string;
  formatVnd: (value: number) => string;
  onCardClick?: (payload: { cardKey: string; title: string }) => void;
}

export default function FinancialOverviewRow1({
  totalIncome,
  totalExpense,
  fundBalance,
  supplierDebt,
  netFundAfterDebt,
  periodLabel,
  formatVnd,
  onCardClick,
}: FinancialOverviewRow1Props) {
  const summaryCards = [
    {
      key: 'income',
      title: 'Tổng thu',
      value: formatVnd(totalIncome),
      description: periodLabel,
      icon: <TrendingUp color='success' sx={{ mr: 1 }} />,
      valueColor: 'success.main',
    },
    {
      key: 'expense',
      title: 'Tổng chi',
      value: formatVnd(totalExpense),
      description: periodLabel,
      icon: <TrendingDown color='error' sx={{ mr: 1 }} />,
      valueColor: 'error.main',
    },
    {
      key: 'fund-balance',
      title: 'Tồn quỹ',
      value: formatVnd(fundBalance),
      description: 'Tổng thu - Tổng chi',
      icon: <AccountBalance color='primary' sx={{ mr: 1 }} />,
      valueColor: 'primary.main',
    },
    {
      key: 'supplier-debt',
      title: 'Công nợ NCC',
      value: formatVnd(supplierDebt),
      description: periodLabel,
      icon: <Assessment color='info' sx={{ mr: 1 }} />,
      valueColor: 'warning.main',
    },
    {
      key: 'net-fund',
      title: 'Quỹ ròng',
      value: formatVnd(netFundAfterDebt),
      description: 'Tồn quỹ - Công nợ NCC',
      icon: <Assessment color='secondary' sx={{ mr: 1 }} />,
      valueColor: 'secondary.main',
    },
  ] as const;

  return (
    <Box sx={{ width: '100%', border: '1px solid #e5e7eb', borderRadius: 0 }}>
      <Grid container size={{ xs: 12 }} spacing={0} rowSpacing={2}>
        {summaryCards.map((card, index) => (
          <Grid
            key={card.key}
            size={{ xs: 12, md: 2.4 }}
            onClick={() => onCardClick?.({ cardKey: card.key, title: card.title })}
            sx={{
              p: 2,
              cursor: onCardClick ? 'pointer' : 'default',
              borderRight: { md: index < summaryCards.length - 1 ? '1px solid #e5e7eb' : 'none' },
              borderBottom: { xs: index < summaryCards.length - 1 ? '1px solid #e5e7eb' : 'none', md: 'none' },
              transition: 'background-color 0.2s ease',
              '&:hover': {
                backgroundColor: onCardClick ? '#f9fafb' : 'transparent',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              {card.icon}
              <Typography variant='h6'>
                {card.title}
              </Typography>
            </Box>
            <Typography variant='h4' color={card.valueColor}>
              {card.value}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {card.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
